var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 28,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 28,
    rx: 4,
    fill: "#F66700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.86 20.369h-2.394l6.366-11.99h2.696l.91 11.99H34.63l-.198-2.775h-3.23l-1.343 2.775Zm2.097-4.335h2.364l-.302-4.262-2.062 4.262ZM24.87 20.4c.954-.18 1.663-.534 2.29-1.101 1.244-1.13 1.698-3.122.979-4.428-.374-.678-1.137-1.155-1.765-1.611-.628-.456-1.13-.884-1.338-1.365-.208-.482-.155-1.05.12-1.361.71-.798 1.858-.597 2.714-.33.488.154.875.386 1.206.696l.99-1.796c-.46-.373-.981-.639-1.718-.835-.737-.195-1.69-.32-2.517-.25-.828.07-1.531.334-2.154.803a4.684 4.684 0 0 0-1.47 1.867c-.306.726-.388 1.51-.186 2.176.41 1.345 1.473 1.939 2.415 2.58.412.28.766.599.957.98.19.38.217.824-.013 1.192s-.715.661-1.275.765c-.56.105-1.193.02-1.782-.183a4.688 4.688 0 0 1-1.607-.95l-.622 2.103c1.31 1.322 3.175 1.35 4.776 1.048ZM21.706 8.379h-2.968l-3.334 11.99h2.967l3.335-11.99Zm-3.797 0-6.494 11.99H8.59l-.255-9.487c-.012-.43-.022-.876-.165-1.22a1.488 1.488 0 0 0-.665-.753 2.094 2.094 0 0 0-1.037-.258V8.38h4.659l.228 8.162 4.16-8.162h2.393Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7f2c6c96605f589bf60b2220107cec8e.svg";
export { ForwardRef as ReactComponent };